module.exports = __webpack_public_path__ + "media/images/logo-1c2756dd57262ecc0f6e9769e6bff6c9.png";